import React, { Component } from "react"
import { Accordion, Divider, Header, Icon } from "semantic-ui-react"
import { Link, withRouter } from "react-router-dom"
import queryString from "qs"
import "./FilterSubmeta.scss"
import { action, observable, observer } from "mobx-react"
import _ from "lodash"
import shop from "shop/shop"

@observer
@withRouter
export default class FilterSubmeta extends Component {

  state = {
    menu         : false,
    current      : false,
    activeIndexes: [0]
  }

  handleClick = ( e, titleProps ) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState( { activeIndex: newIndex } )
  }

  render() {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const { fieldValue, field: fieldName } = query
    const { activeIndex } = this.state
    const { fields = {}, title = "Filter", useTranslate = true } = this.props
    if(!shop.config.pickFilter)return null
    return (
      <div className="CategoriesFilter FilterSubmeta">
        <Header as="h3"> {title}</Header>
        {_.map( fields, ( field, name ) => {
            if ( !_.includes( shop.config.pickFilter, name ) ) return null
            let active = fieldName === name
            if ( activeIndex ) {
              active = activeIndex === name
            }

            // if ( !field ) return null
            return <Accordion key={name}>
              <Accordion.Title active={active} index={name} onClick={this.handleClick}>
                {useTranslate ? translate( name ) : name}
                {active && <Icon name="minus" className="animate rotateIn fr"/>}
                {!active && <Icon name="plus" className="fr"/>}
              </Accordion.Title>
              <Accordion.Content active={active}>
                <FilterAttributes useTranslate={useTranslate} name={name} field={field} fieldValue={fieldValue}/>
                {/*<div>{JSON.stringify(field,null,2)}</div>*/}
              </Accordion.Content>
            </Accordion>
          }
        )
        }
        {/*<pre>{JSON.stringify(category.meta.fields, null, 2)}</pre>*/}
      </div>
    )
  }
}


const FilterAttributes = ( { field, name, fieldValue, useTranslate } ) => {
  return <div className={`FilterAttributes Filter-${name}`}>
    {_.map( field,
      ( value ) => {
        if ( value === "null" || !(value && value.trim()) ) return null
        return (
          <div key={value}>
            <Link to={{
              search: queryString.stringify( {
                field     : name,
                fieldValue: value
              } )
            }}>
              {value === fieldValue ? <Icon name="circle"/> :
                <Icon name="circle outline"/>}

              {useTranslate ? translate( value ) : value}</Link></div>
        )
      } )}
  </div>
}



// WEBPACK FOOTER //
// ./src/components/Category/FilterSubmeta.js